<template>
  <v-row class="pt-6">
    <v-col>
      <ValidationObserver ref="position">
        <v-row v-if="positionInfo.positionNumber" class="text-left pb-2">
          <text-view
              class-flex="pl-1"
              :display="positionInfo.positionNumber"
              :label="$t('Номер позиции')"
              :no-data="$t('Не присвоен')" />
        </v-row>
        <v-row>
          <v-col cols="12" class="pl-2 pr-4 py-0">
            <validatable-text-area
                v-model="position.positionDescription"
                :readonly="readonly"
                rules="required"
                auto-grow
                rows="1"
                :label="$t('Наименование продукта и норматив по качеству')" />
          </v-col>
        </v-row>

        <v-row>
          <v-col cols="12" md="6" class="pl-2 pr-4 py-0">
            <validatable-text-input
                v-model="position.amount"
                :readonly="readonly"
                :rules="{
                  required: true,
                  regex: /^[0-9]{1,11}([.][0-9]{0,2})?$/
                }"
                :label="$t('Количество')"
                data-type="float" />
          </v-col>
          <v-col cols="12" md="6" class="pl-2 pr-4 py-0">
            <validatable-text-input
                v-model="position.unit"
                :readonly="readonly"
                rules="required"
                :label="$t('Единица измерения')" />
          </v-col>
        </v-row>
        <v-row>
          <v-col cols="12" md="6" class="pl-2 pr-4 py-0">
            <validatable-text-input
                v-model="position.contractPart"
                :readonly="readonly"
                rules="required"
                :label="$t('Сторона Договора')" />
          </v-col>
        </v-row>
        <v-row>
          <v-col cols="12" class="pl-2 pr-4 py-0">
            <validatable-text-area
                v-model="position.deliveryCondition"
                :readonly="readonly"
                rules="required"
                auto-grow
                rows="1"
                :label="$t('Условия поставки')" />
          </v-col>
        </v-row>
      </ValidationObserver>
    </v-col>
  </v-row>
</template>

<script>
  import Vue from 'vue'
  import ValidatableTextInput from '@/components/reused/ui/ValidatableTextInput.vue'
  import TextView from '@/components/reused/ui/TextView.vue'
  import ValidatableTextArea from '@/components/reused/ui/ValidatableTextarea.vue'

  export default {
    components: {
      ValidatableTextInput,
      TextView,
      ValidatableTextArea
    },
    props: {
      readonly: {
        type: Boolean,
        default: false
      },
      lotOwnerOrganizationName: {
        type: String,
        default: null
      },
      positionInfo: {
        type: Object,
        default: () => {
          return {}
        }
      },
      validated: {
        type: [Function, Promise]
      }
    },
    data () {
      return {
        isLoading: false,
        position: {
          positionDescription: null,
          amount: null,
          unit: null,
          deliveryCondition: null,
          cargoDescription: null,
          contractCondition: null,
          contractPart: this.lotOwnerOrganizationName
        }
      }
    },
    watch: {
      positionInfo: {
        deep: true,
        immediate: true,
        handler: function (newVal) {
          if (newVal.positionTemplateId) {
            this.mapFields(newVal)
          }
        }
      },
      lotOwnerOrganizationName: {
        deep: true,
        immediate: true,
        handler: function (newVal, oldVal) {
          if (newVal !== oldVal && !this.position.contractPart) {
            this.position.contractPart = newVal
          }
        }
      }
    },
    methods: {
      validate: async function () {
        const vm = this
        const result = await vm.$refs.position.validate()
        if (!result) {
          throw new Vue.errorsTypes.ValidationError()
        }
        if (vm.validated) {
          await vm.validated(vm.position)
        }
      },
      mapFields: function (position) {
        this.position.positionDescription = position.positionDescription
        this.position.amount = position.amount
        this.position.unit = position.unit
        this.position.deliveryCondition = position.deliveryCondition
        this.position.cargoDescription = position.cargoDescription
        this.position.contractCondition = position.contractCondition
        this.position.contractPart = position.contractPart
      }
    }
  }
</script>
